import React, { Fragment } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Calendar from '../../../shared/components/Calendar';

const BigCalendar = (props) => {
  const { events, selectEvent, onRangeChange } = props;
  return (
    <Fragment>
      <Col md={12} lg={12} xl={9}>
        <Card>
          <CardBody>
            <Calendar
              events={events}
              selectEvent={selectEvent}
              onRangeChange={onRangeChange}
            />
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

BigCalendar.propTypes = {
  selectEvent: PropTypes.func.isRequired,
  onRangeChange: PropTypes.func.isRequired,
  events: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(BigCalendar)
);
